module.exports = __webpack_public_path__ + "media/images/pc/items/gift/gift_thanks_02-3634f2cf8f34d8bfb4ffaa47908855c0.jpg";